import MonthlyMinMaxChart from './MinMaxChart'

const MinMax = ({data}) => {
    return data && data.length ? (
        <>
            <h3 className="text-center" style={{marginTop: 0}}>Min/Max Balance</h3>
            <MonthlyMinMaxChart data={data} />
        </>
    ) : null
}

export default MinMax
